import { z } from "zod";
import type { SensorStatus } from "@/features/deployment-dashboard/types";

const LIVE_SENSOR_STATUSES = ["ONLINE", "OFFLINE", "MAINTENANCE"] as const;

const sensorStatusSchema: z.ZodType<SensorStatus> = z.enum(LIVE_SENSOR_STATUSES);
const timestampSchema = z.string().datetime({ offset: true });
const vector3Schema = z
  .object({
    x: z.number().finite(),
    y: z.number().finite(),
    z: z.number().finite(),
  })
  .strict();
const quaternionXyzwSchema = vector3Schema
  .extend({
    w: z.number().finite(),
  })
  .strict();

const liveSensorSchema = z
  .object({
    sensor_id: z.string().min(1),
    sensor_display_name: z.string().min(1),
    status: sensorStatusSchema,
    first_registered_at: timestampSchema,
    last_registration_sent_at: timestampSchema,
    last_registration_received_at: timestampSchema,
    registration_count: z.number().int().nonnegative(),
    parent_frame_id: z.string().min(1),
    child_frame_id: z.string().min(1),
    translation_meters: vector3Schema,
    rotation_xyzw: quaternionXyzwSchema,
  })
  .strict();

export const liveSensorsResponseSchema = z
  .object({
    sensors: z.array(liveSensorSchema),
  })
  .strict();

export type LiveSensor = z.infer<typeof liveSensorSchema>;
